import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { Content, MainContainer } from "styles/styles";
import { SideBar } from "components/nav/SideBar";
import { useNavigationStore } from "store/navigationStore";
import { useProcessVhStore } from "store/processVhStore";
import {
  FlowBody,
  FlowLayoutContainer,
  MediaSectionWrapper,
  ScriptContainer,
} from "../VoiceUnderstandingPage";
import { MediaFileSection } from "features/results/MediaFileSection";
import FlowHeader from "features/results/FlowHeader";
import ScriptSection, {
  ScriptSectionTab,
} from "features/results/ContentSection";

const VH_TABS: ScriptSectionTab[] = ["Voice Highlight", "전체 텍스트"];
const VH_TAGS = ["보이스하이라이트"];

const VoiceHighlightPage: React.FC = () => {
  const { projectId, documentId } = useParams<{
    projectId: string;
    documentId: string;
  }>();
  const location = useLocation();
  const { isCollapsed } = useNavigationStore();

  // 1. Try to get result from location state first
  const resultFromState = location.state?.result;

  // 2. If not available, get it from the Zustand store (for refresh)
  const resultFromStore = useProcessVhStore((state) =>
    documentId ? state.results[documentId] : null
  );
  const hasHydrated = useProcessVhStore((state) => state._hasHydrated);

  const result = resultFromState || resultFromStore;
  const projectName = location.state?.projectName;

  // Show loading indicator only when fetching from store after hydration
  if (!resultFromState && !hasHydrated) {
    return <div>결과를 로딩 중입니다...</div>;
  }

  // If after hydration, there's still no result, it's an error
  if (!documentId || !result) {
    return <div>결과를 찾을 수 없습니다.</div>;
  }

  return (
    <MainContainer>
      <Content $isCollapsed={isCollapsed}>
        <SideBar />
        <FlowLayoutContainer>
          <FlowHeader
            tags={VH_TAGS}
            projectId={projectId}
            initialName={projectName}
          />
          <FlowBody>
            <MediaSectionWrapper>
              <MediaFileSection projectId={"audion_vh"} result={result} />
            </MediaSectionWrapper>
            <ScriptContainer>
              <ScriptSection
                tabs={VH_TABS}
                initialTab="Voice Highlight"
                result={result}
                documentId={documentId}
              />
            </ScriptContainer>
          </FlowBody>
        </FlowLayoutContainer>
      </Content>
    </MainContainer>
  );
};

export default VoiceHighlightPage;
